export const labels = {
	// reused label
	fontTooltip: {
		label: "Label.MobileCreator.Tooltip.Font",
		default: "Font",
	},
	fontColorTooltip: {
		label: "Label.MobileCreator.Tooltip.FontColour",
		default: "Color",
	},
	boldTooltip: {
		label: "Label.MobileCreator.Tooltip.Bold",
		default: "Bold",
	},
	italicTooltip: {
		label: "Label.MobileCreator.Tooltip.Italic",
		default: "Italic",
	},
	underlineTooltip: {
		label: "Label.MobileCreator.Tooltip.Underline",
		default: "Underline",
	},
	clearTooltip: {
		label: "Label.MobileCreator.Tooltip.Clear",
		default: "Clear",
		// description: "Clears the content of the text zone. It does NOT delete the text zone"
	},
	deleteTooltip: {
		label: "Label.MobileCreator.Tooltip.Delete",
		default: "Delete",
	},
} as const;
